import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HttpInterceptorHandlerService } from '../handlers/http.interceptor-handler.service';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const httpInterceptorHandlerService: HttpInterceptorHandlerService = this.injector.get(HttpInterceptorHandlerService);
    console.log(req)
    if (req.url.includes('methodUrlResponse')){
      console.log('redi ;)');
    }
    return next.handle(req)
      .pipe(
        tap (evt => {
          httpInterceptorHandlerService.manageSuccess(evt);
        }),
        catchError ((error: HttpErrorResponse) => {
          return httpInterceptorHandlerService.manageErrors(error);
        })
      );
  }

}
